import { render, staticRenderFns } from "./imageLightBoxDetailSection.vue?vue&type=template&id=63eb8ef8&scoped=true&"
import script from "./imageLightBoxDetailSection.vue?vue&type=script&lang=js&"
export * from "./imageLightBoxDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb8ef8",
  null
  
)

export default component.exports